__turbopack_context__.v({
  "next": "PrevNextButtons-module-scss-module__Zmp8xW__next",
  "prev": "PrevNextButtons-module-scss-module__Zmp8xW__prev",
});
